module.exports = __webpack_public_path__ + "static/media/banner.f8da4e99.jpeg";